module.exports = __webpack_public_path__ + "img/logo-3.d0fd1582.png";